import React from 'react';
import profile1 from './profile1.jpg';
import profile2 from './profile2.jpg';
import profile3 from './profile3.jpg';
import css from './StepsSection.module.css';
import { useHistory } from 'react-router-dom';

import ScatterPlotRoundedIcon from '@mui/icons-material/ScatterPlotRounded';
import FormatOverlineRoundedIcon from '@mui/icons-material/FormatOverlineRounded';
import CropRoundedIcon from '@mui/icons-material/CropRounded';

const StepsSection = () => {
  const history = useHistory();
  return (
    <div className={css.wrapper}>
      <div className={css.box}>
        <div className={css.boxLeft}>
          <div className={css.iconBox}>
            <ScatterPlotRoundedIcon className={css.icon} />
          </div>
          <p className={css.title}>1. Become a creator</p>
          <p className={css.description}>
            Turn your scans into something bigger. Scanwow gives makers a simple, supportive space
            to upload, showcase, and sell 3d data—whether it’s a textured photogrammetry model or a
            raw point cloud.
            <br />
            <br />
            You set the price, retain ownership, and join a growing community of artists,
            archivists, and technologists pushing the limits of what’s possible in 3d.
          </p>
          <p className={css.note}>Upload your scans, get paid, and be part of something big.</p>
          <button
            type="button"
            onClick={() => history.push('/l/new')}
            className={css.quickActionButton}
          >
            <span>Start Selling Your Scans</span>
          </button>
        </div>
        <img src={profile1} className={css.boxImage} />
      </div>

      <div className={css.box2}>
        <div className={css.boxLeft}>
          <div className={css.iconBox2}>
            <FormatOverlineRoundedIcon className={css.icon} />
          </div>

          <p className={css.title2}>2. Buy scans</p>
          <p className={css.description2}>
            Need scan data for your next game, artwork, simulation or prototype? Browse Scanwow’s
            growing marketplace of high-quality assets, ready to download in multiple formats.
            <br /> <br />
            Filter by type, resolution, price or purpose—and discover everything from gritty urban
            textures to heritage artefacts, scanned and shared by real creators.
          </p>
          <p className={css.note2}>Need the perfect 3d dataset? We’ve got it.</p>
          <button
            type="button"
            onClick={() => history.push('/s')}
            className={css.quickActionButton2}
          >
            <span>Explore 3d Assets</span>
          </button>
        </div>
        <img src={profile2} className={css.boxImage} />
      </div>

      <div className={css.box}>
        <div className={css.boxLeft}>
          <div className={css.iconBox}>
            <CropRoundedIcon className={css.icon} />
          </div>

          <p className={css.title}>3. Learn how it works</p>
          <p className={css.description}>
            Capture the world around you. Turn that data into something shareable with simple tools
            and clear export options.
            <br />
            <br />
            Then, Create assets that others can use, remix, and learn from.
            <br />
            <br />
            Once it’s live, you Connect—with fellow makers, buyers, and collaborators through your
            profile, posts, and sales right here. Scanwow is more than a marketplace. It’s a
            launchpad for creativity.
          </p>
          <p className={css.note}>
            Capture, Create & Connect. It’s so easy.
            <br /> <br />
            New to this? We’ve got tutorials, guides, and stories to help get you started.
          </p>
          <button
            type="button"
            onClick={() =>
              typeof window !== 'undefined' && (window.location.href = '/static/docs/howto.pdf')
            }
            className={css.quickActionButton}
          >
            <span>Get The How-To</span>
          </button>
        </div>
        <img src={profile3} className={css.boxImage} />
      </div>
    </div>
  );
};

export default StepsSection;
